module.exports = __webpack_public_path__ + "static/media/icon-zip.2c0d44cb.svg";